import {
    ManagementDTO,
    ManagementFlatDTO,
} from "../domain/models/dto/ManagementDTO";
import {
    IManagementFlat,
    ManagementFlatCollection,
} from "../domain/models/Management";
import { ManagementService } from "../domain/services/ManagementService";
import { ManagementFlatMapper } from "../mappers/ManagementFlatMapper";
import { BaseServiceImpl } from "./BaseServiceImpl";
import { LanguageServiceImpl } from "./LanguageServiceImpl";

export class ManagementServiceImpl
    extends BaseServiceImpl
    implements ManagementService
{
    static _instance: ManagementService;
    private readonly endpoint = "/api/v1/management";

    private constructor() {
        super();
    }

    static getInstance(): ManagementService {
        if (!ManagementServiceImpl._instance) {
            ManagementServiceImpl._instance = new ManagementServiceImpl();
        }
        return ManagementServiceImpl._instance;
    }

    async getAll(
        currentPage: number,
        currentLimit?: number,
        filtersDTO: ManagementDTO = {} as ManagementDTO
    ): Promise<ManagementFlatCollection> {
        try {
            let url = `${this.endpoint}?page=${currentPage}${
                currentLimit ? `&limit=${currentLimit}` : ""
            }&lang=${
                LanguageServiceImpl.getInstance().currentLang
            }&isActive=true`;

            Object.entries(filtersDTO).forEach(([key, value]) => {
                if (key && value !== null && value !== undefined) {
                    url += `&${key}=${value}`;
                }
            });

            const result = await this.get<ManagementFlatCollection>(url);
            return {
                ...result,
                rows: result.rows.map((dto) =>
                    new ManagementFlatMapper().fromDTO(dto)
                ),
            };
        } catch (err) {
            console.log("Error in ManagementServiceImpl.getAll");
            console.log(err);
        }
    }

    async getById(id: string): Promise<IManagementFlat | null> {
        try {
            if (!id) return null;

            const dto = await this.get<ManagementFlatDTO>(
                `${this.endpoint}/${id}?lang=${
                    LanguageServiceImpl.getInstance().currentLang
                }`
            );
            return new ManagementFlatMapper().fromDTO(dto);
        } catch (err) {
            console.log("Error in ManagementServiceImpl.getById");
            console.log(err);
            return null;
        }
    }
}

export function managementServiceFactory(): ManagementService {
    return ManagementServiceImpl.getInstance();
}
